export default __webpack_public_path__ + "static/media/19.d1a983e6.jpg";